'use client';

import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { AccountOrder } from '../types';

interface FilledCellProps {
	order: AccountOrder;
	showAccountValues: boolean;
}

export function FilledCell({ order, showAccountValues }: FilledCellProps) {
	return (
		<NumberDisplay
			value={order.baseAssetAmountFilled}
			type="number"
			precision="trade"
			isAccountValueToHide={!showAccountValues}
			trimZeroes
		/>
	);
}
